<template>
  <div
      class="cart-widget__overview"
  >
    <div class="cart-widget__overview__price">
      <div v-if="totalOneTime">
        <div>
          Gesamt einmalig
        </div>
        <div>
          {{ totalOneTimeFormatted }}&thinsp;€
        </div>
      </div>
      <div v-if="totalPerMonth">
        <div>
          Gesamt pro Monat
        </div>
        <div>
          {{ totalPerMonthFormatted }}&thinsp;€
        </div>
      </div>
    </div>
    <div class="cart-widget__overview__actions">
      <div
          class="cart-widget__overview__entry"
          :class="{ 'inactive': isOrderPage }"
      >
        <BaseButton
            link-type="button"
            color="red-orange"
            width="full"
            text-align="center"
            @click.prevent="gotoOrder"
        >
          Jetzt bestellen
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import BaseButton from '@/components/BaseButton.vue';
import {
  computed,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { formatNumber } from '@/helpers';

const emit = defineEmits(['close']);
const router = useRouter();
const store = useStore();
const isOrderPage = computed(() => store.getters['page/pageType'] === 'order');

const totalPerMonth = computed(() => store.getters['cart/perMonth']);
const totalPerMonthFormatted = computed(() => formatNumber(totalPerMonth.value, 2));
const totalOneTime = computed(() => store.getters['cart/oneTime']);
const totalOneTimeFormatted = computed(() => formatNumber(totalOneTime.value, 2));

const gotoOrder = () => {
  if (!isOrderPage.value) {
    router.push('/bestellung/adresse/');
    emit('close');
  }
};
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.cart-widget__overview {
  &__price {
    padding: 20px 40px;
    display: grid;
    gap: 20px;
    width: 100%;
    grid-template-columns: 100%;
    background-color: #ECF2F6;

    > div {
      display: grid;
      width: 100%;
      gap: 20px;
      grid-template-columns: 1fr auto;

      > div {
        font-size: 1.125rem;
        font-weight: 700;

        @media (min-width: map_get($grid-breakpoints, 'lg')) {
          font-size: 1.5rem;
        }

        &:last-child {
          font-weight: 700;
        }
      }
    }
  }

  &__actions {
    display: grid;
    grid-template-columns: 100%;
    gap: 20px;
    padding: 20px 40px 30px;
  }
}
</style>
